import {toast, ToastCard} from '@sollapay/ui/components';

import {useDealTypeTranslation} from '@/lib/i18n';

import type {SupplementaryRevocationReason, TrustPurpose} from '@sollapay/enums';
import type {FC} from 'react';

export type SupplementaryDeclarationRevokedToastProps = {
  toastId: string | number;
  reason: SupplementaryRevocationReason;
  trustPurpose: TrustPurpose | null;
};

export const SupplementaryDeclarationRevokedToast: FC<
  SupplementaryDeclarationRevokedToastProps
> = ({toastId, reason, trustPurpose}) => {
  // Renders in the toast portal at app root, outside every provider.
  const {t} = useDealTypeTranslation('trustAccounts', trustPurpose);
  const dismiss = () => toast.dismiss(toastId);

  return (
    <ToastCard
      iconName="sollapay:compliance"
      title={t(`activation.supplementaryRevokedToast.${reason}.title`)}
      description={t(`activation.supplementaryRevokedToast.${reason}.description`)}
      onClose={dismiss}
      closeLabel={t('activation.supplementaryRevokedToast.close')}
    />
  );
};

export function showSupplementaryDeclarationRevokedToast(
  trustAccountId: string,
  reason: SupplementaryRevocationReason,
  trustPurpose: TrustPurpose | null
): void {
  const toastId = `supplementary-revoked-${trustAccountId}`;
  toast.custom(
    id => (
      <SupplementaryDeclarationRevokedToast
        toastId={id}
        reason={reason}
        trustPurpose={trustPurpose}
      />
    ),
    {id: toastId, duration: 15_000}
  );
}
